import { h } from 'preact';
import Control from '../control';
import OptOutMainComponent, { OptOutMainPropsType } from './index';
import { RootStore } from '../../js/stores/root.store';
import OguryIcon from './ogury-icon';

interface OptOutIconPropsType extends OptOutMainPropsType {
  style: h.JSX.CSSProperties;
  isInterstitialAdUnit: boolean;
}

export default class OptOutIcon extends OptOutMainComponent<
  OptOutIconPropsType
> {
  render() {
    const { style, isInterstitialAdUnit } = this.props;
    const videoStore = RootStore.getInstance().videoStore;
    const isExpanded = videoStore.isVideoExpanded.value;
    const childPrivacyApplied = videoStore.isChildPrivacyApplied;

    let containerStyle: h.JSX.CSSProperties = {
      ...style
    } as h.JSX.CSSProperties;

    if (childPrivacyApplied) {
      containerStyle = {
        ...containerStyle,
        height: '20px',
        minHeight: '20px',
        width: '44px',
        lineHeight: '20px'
      };
      if (isInterstitialAdUnit || isExpanded) {
        containerStyle = {
          ...containerStyle,
          padding: '4px',
          height: '24px',
          minHeight: '24px',
          lineHeight: '24px'
        };
      }
    }

    return (
      <div data-zone="optout">
        <Control
          id="optout"
          onTouchStart={e => e.stopPropagation()}
          onClick={(e: MouseEvent) => {
            e.stopPropagation();
            this.onClick(e);
          }}
          isInterstitialAdUnit={this.props.isInterstitialAdUnit}
          style={containerStyle}
        >
          {childPrivacyApplied ? (
            <OguryIcon />
          ) : (
            <svg
              viewBox="0 0 30 30"
              width={this.props.iconSize}
              height={this.props.iconSize}
              xmlns="http://www.w3.org/2000/svg"
            >
              <g fill="#FFF">
                <g>
                  <circle r="1.470929" cy="8.625972" cx="14.511199" />
                  <path d="m16.021747,19.898431l0,-7.844958l-3.922479,0l0,1.96124l1.96124,0l0,5.883719l-1.96124,0l0,1.96124l5.883719,0l0,-1.96124" />
                </g>
                <path d="m15,0.290704c-8.125474,0 -14.709296,6.583822 -14.709296,14.709296c0,8.125474 6.583822,14.709296 14.709296,14.709296c8.125474,0 14.709296,-6.583822 14.709296,-14.709296c0,-8.125474 -6.583822,-14.709296 -14.709296,-14.709296zm-0.050816,27.447233c-7.392304,0.01012 -12.697241,-5.336042 -12.697241,-12.742997c0,-7.317502 5.297955,-12.742997 12.697241,-12.742997c7.272296,0 12.798873,5.418493 12.697241,12.742997c0.101631,7.399953 -5.424945,12.753117 -12.697241,12.743016l0,-0.00002z" />
              </g>
            </svg>
          )}
        </Control>
      </div>
    );
  }
}
